import type { ReactNode } from 'react';
import { clsx } from '../../../ds/clsx';
import { useFieldIds } from '../../../ds/hooks';
import styles from './ConsentRow.module.css';

export interface ConsentRowProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: ReactNode;
  error?: string | undefined;
  name?: string | undefined;
}

/** The 16 px consent checkbox with its sentence in the sunken box. */
export function ConsentRow({ checked, onChange, children, error, name = 'consent' }: ConsentRowProps) {
  const ids = useFieldIds(undefined, { error: Boolean(error) });
  return (
    <>
      <label className={clsx(styles.row, error && styles.invalid)}>
        <input
          id={ids.inputId}
          type="checkbox"
          name={name}
          className={styles.input}
          checked={checked}
          aria-invalid={error ? true : undefined}
          aria-describedby={ids.describedBy}
          onChange={(event) => onChange(event.target.checked)}
        />
        <span className={styles.box} aria-hidden="true">
          {checked ? '✓' : null}
        </span>
        <span className={styles.text}>{children}</span>
      </label>
      {error ? (
        <div id={ids.errorId} className={styles.error} role="alert">
          {error}
        </div>
      ) : null}
    </>
  );
}
